import { css } from '../../styles/theme';
import { rem } from 'polished';

export const StylesDS = css``;
